import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	height: "800px",
	width: "800px",
	id: "_x32_",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 512 512",
	xmlSpace: "preserve",
	fill: "#000000",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_bgCarrier",
			strokeWidth: 0
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_tracerCarrier",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "SVGRepo_iconCarrier",
			children: [/* @__PURE__ */ _jsx("style", {
				type: "text/css",
				children: " .st0{fill:#81ba43;} "
			}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M256,86.069 c28.463,0,51.538,23.074,51.538,51.538c0,28.464-23.074,51.538-51.538,51.538c-28.463,0-51.538-23.074-51.538-51.538 C204.462,109.143,227.537,86.069,256,86.069z M310.491,425.931H201.51v-43.593h35.667V276.329H215.38v-43.593h65.389v3.963v39.63 v106.009h29.722V425.931z"
			}) })]
		})
	]
});
const ForwardRef = forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
